import React, { useState, useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { useNavigate, Link } from "react-router-dom";
import SegmentRoundedIcon from "@mui/icons-material/SegmentRounded";
import logo from "../../assets/Images/logo.png";
import "../Header/Header.css";

const Header = () => {
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const navItems = ["Trading", "Platforms", "Tools", "Partner", "About us"];
  const navigate = useNavigate();
  return (
    <>
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "#1D1D1D",
          padding: "5px 20px",
          zIndex: "999",
          position: "fixed",
        }}
      >
        <Toolbar
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            maxWidth: { sm: "900px", lg: "1150px", xl: "1500px" },
            margin: { sx: "0", md: "0 auto" },
            width: { sx: "auto", md: "100%" },
            padding: "0",
          }}
        >
          {/* Logo */}
          <Link>
            <div className="logo">
              <img src={logo} alt="" />
            </div>
          </Link>

          {/* Desktop Navigation */}
          <Box sx={{ display: { xs: "none", md: "flex" }, gap: "20px" }}>
            {navItems.map((item) => (
              <Typography
                key={item}
                sx={{
                  color: "white",
                  cursor: "pointer",
                }}
              >
                {item}
              </Typography>
            ))}
          </Box>

          {/* Buttons */}
          <Box
            sx={{
              display: { xs: "none", md: "flex" },
              alignItems: "center",
              gap: "15px",
            }}
            className="header-btn"
          >
            <Button
              onClick={() => {
                navigate("/contactrequest");
              }}
              sx={{ textTransform: "none" }}
            >
              Sign in
              {/* Contact Request */}
            </Button>
            <Button
              onClick={() => {
                navigate("/contactrequest");
              }}
              variant="outlined"
              sx={{
                borderColor: "#FFD700",
                color: "#FFD700",
                textTransform: "none",
                borderRadius: "8px",
                transition: "all 0.3s ease-in-out",
                "&:hover": {
                  transform: "scale(1.05)",
                },
              }}
            >
              My Account
            </Button>
          </Box>

          {/* Mobile Menu Button */}
          <IconButton
            edge="end"
            color="inherit"
            aria-label="menu"
            onClick={handleDrawerToggle}
            sx={{ display: { md: "none" } }}
          >
            <SegmentRoundedIcon />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* Mobile Drawer */}
      <Drawer
        anchor="left"
        open={mobileOpen}
        onClose={handleDrawerToggle}
        sx={{
          "& .MuiDrawer-paper": { width: 250, backgroundColor: "#1D1D1D" },
        }}
      >
        <List>
          {navItems.map((item) => (
            <ListItem button key={item} onClick={handleDrawerToggle}>
              <ListItemText
                primary={item}
                sx={{ color: "white", textAlign: "center" }}
              />
            </ListItem>
          ))}
          <ListItem button onClick={handleDrawerToggle}>
            <ListItemText
              // primary="Sign in"
              primary="Contact Request"
              className="header-btn-mob"
              onClick={() => {
                navigate("/contactrequest");
              }}
              sx={{ color: "#FFD700", textAlign: "center" }}
            />
          </ListItem>
          <ListItem
            button
            onClick={handleDrawerToggle}
            className="header-btn-mob"
            sx={{ textAlign: "center" }}
            style={{ justifyContent: "center" }}
          >
            <Button
              variant="outlined"
              onClick={() => {
                navigate("/contactrequest");
              }}
              sx={{
                color: "#FFD700",
                borderColor: "#FFD700",
              }}
            >
              My Account
            </Button>
          </ListItem>
        </List>
      </Drawer>
    </>
  );
};

export default Header;
